import { useSearchParams } from "react-router-dom";
import Membership from "@/components/Membership/Membership";
import { useSettingsVersionedFeatures } from "@/hooks/useSettingsVersionedFeatures";
import TieredMembership from "@/components/Membership/TieredMembership";

function MembershipPage() {
  const [searchParams] = useSearchParams();
  const fromParam = searchParams.get("from") || undefined;
  const closeOnBack = !!fromParam;
  const referrer = searchParams.get("referrer") || undefined;
  const { enabled: tieredSubsEnabled } = useSettingsVersionedFeatures(
    "TIERED_SUBS_MINPROFILE_VERSION"
  );
  return tieredSubsEnabled ? (
    <TieredMembership />
  ) : (
    <Membership closeOnBack={closeOnBack} referrer={referrer} fromParam={fromParam} />
  );
}

export default MembershipPage;
